import styled, {css} from "styled-components"
import {media} from "utils/Media"

// Remove color from props to stop invalid html
const Button = styled('a').withConfig({
    shouldForwardProp: (prop, defaultValidatorFn) => !['color', 'small'].includes(prop),
})`
  border: 0;
  padding: 0;
  display: inline-block;
  text-transform: uppercase;
  text-decoration: none !important;
  white-space: nowrap;
  font-size: ${props => props.theme.font.size.base};
  font-family: ${props => props.theme.font.family.black};
  font-weight: ${props => props.theme.font.weight.bold};
  //font-style: italic;
    /* font-weight: ${props => props.theme.font.family.bold}; */
  background-color: transparent;
  color: ${props => props.theme.colors.secondary};
  border: 3px solid ${props => props.theme.colors.secondary};
  line-height: 1;
  position: relative;
  padding: .85rem 1rem;
  text-align: center;
  transition: all .2s ease-in-out;


  @media ${media.md} {
    font-size: ${props => props.theme.font.size.base};
    padding: .95rem 1.25rem;
  }

  ${props => props.small && css`
    padding: .5rem 1rem;
  `}
  &:hover {
    background: ${props => props.theme.colors.secondary};
    border-color: ${props => props.theme.colors.secondary};
    color: ${props => props.theme.colors.white};
    cursor: pointer;
    text-decoration: none;

    &:before {
      border-width: 4px;
    }
  }

  ${props => props.color === "primary" && css`
    background: ${props => props.theme.colors.primary};
    border-color: ${props => props.theme.colors.primary};
    color: ${props => props.theme.colors.white};

    &:hover {
      background: ${props => props.theme.colors.primary};
      border-color: ${props => props.theme.colors.primary};
      color: ${props => props.theme.colors.black};
    }
  `}
  ${props => props.color === "secondary" && css`
    background-color: transparent;
    color: ${props => props.theme.colors.black};
    border: 3px solid ${props => props.theme.colors.secondary};

    &:hover {
      background-color: none;
      color: ${props => props.theme.colors.white};
    }

    &:active {
      background: none;
      border-color: ${props => props.theme.colors.secondary};
      color: ${props => props.theme.colors.black};
    }
  `}
  ${props => props.color === 'tertiary' && css`
    border: solid 3px ${props => props.theme.colors.secondary};
    color: ${props => props.theme.colors.white};

    &:hover {
      color: ${props => props.theme.colors.black};
    }
  `}
  ${props => props.color === 'main' && css`
    background-color: ${props => props.theme.colors.primary};
    border: solid 3px ${props => props.theme.colors.primary};
    color: ${props => props.theme.colors.white};

    &:hover {
      color: ${props => props.theme.colors.black};
    }
  `}
  ${props => props.color === 'alt' && css`
    border: solid 3px ${props => props.theme.colors.secondary};
    background-color: ${props => props.theme.colors.secondary};
    color: ${props => props.theme.colors.black};

    &:hover {
      background-color: ${props => props.theme.colors.secondary};
    }
  `}
  ${props => props.color === 'regular' && css`
    border: solid 3px ${props => props.theme.colors.secondary};
    background-color: ${props => props.theme.colors.secondary};
    color: ${props => props.theme.colors.black};

    &:hover {
      background-color: transparent;
      color: ${props => props.theme.colors.black};
    }
  `}
  ${props => props.color === "grey" && css`
    background-color: ${props => props.theme.colors.grey3};
    color: ${props => props.theme.colors.white};
    border: 3px solid ${props => props.theme.colors.grey3};

    &:hover {
      background-color: ${props => props.theme.colors.grey3};
      color: ${props => props.theme.colors.white};
    }

    &:active {
      background-color: ${props => props.theme.colors.grey3};
      color: ${props => props.theme.colors.white};
      border: 3px solid ${props => props.theme.colors.grey3};
    }
  `}
  ${props => props.color === "orange" && css`
    background-color: ${props => props.theme.colors.orange};
    color: ${props => props.theme.colors.white};
    border: 3px solid ${props => props.theme.colors.orange};

    &:hover {
      background-color: transparent;
      color: ${props => props.theme.colors.orange};
      border-color: ${props => props.theme.colors.orange};
    }

    &:active {
      background: ${props => props.theme.colors.primary};
      border-color: ${props => props.theme.colors.primary};
      color: ${props => props.theme.colors.black};
    }
  `}
  ${props => props.color === "white" && css`
    background-color: transparent;
    color: ${props => props.theme.colors.black};
    border-color: ${props => props.theme.colors.white};

    &:hover {
      background-color: ${props => props.theme.colors.secondary};
      border-color: ${props => props.theme.colors.secondary};
      color: ${props => props.theme.colors.black};
    }

    &:active {
      background-color: ${props => props.theme.colors.secondary};
      border-color: ${props => props.theme.colors.secondary};
      color: ${props => props.theme.colors.white};
    }
  `}
  &:disabled {
    pointer-events: none;
  }
`;

export default Button